export default __webpack_public_path__ + "static/media/templateOptionOne.ba4041a0.png";